/**
 * Paywall visibility atoms
 *
 * Controls whether the paywall modal is displayed. The paywall is shown
 * when the current user's customer (per CLA-173, subscriptions are
 * owned by `customerId`) lacks an active subscription.
 *
 * @since 1.0.0
 */
import { Atom } from "@effect-atom/atom-react";

/**
 * Whether paywall is currently shown
 *
 * @since 1.0.0
 */
export const paywallVisibleAtom = Atom.make(false);

/**
 * Show paywall action
 *
 * @example
 * ```typescript
 * import { showPaywall } from "~/lib/atoms/paywall";
 *
 * // When user hits a paywall trigger:
 * showPaywall();
 * ```
 *
 * @since 1.0.0
 */
export const showPaywall = () => Atom.set(paywallVisibleAtom, true);

/**
 * Hide paywall action
 *
 * @example
 * ```typescript
 * import { hidePaywall } from "~/lib/atoms/paywall";
 *
 * // When user closes paywall:
 * hidePaywall();
 * ```
 *
 * @since 1.0.0
 */
export const hidePaywall = () => Atom.set(paywallVisibleAtom, false);
